import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { selectIsArabic } from './store/selectors/language.selectors';
import * as AuthActions from './store/actions/auth.actions';
import {
  selectAuthLoading,
  selectAuthLogingIn,
  selectAuthUser,
} from './store/selectors/auth.selectors';
import { Roles } from './shared/constants/role.constants';
import { Statuses } from './shared/constants/status.constants';
import { FacebookService } from './services/facebook.service';
declare const FB: any;
declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  isNavbarOpen = false;

  @ViewChild('navbar') navbar!: ElementRef;

  isLoggedIn = false;
  username: string | undefined = undefined;
  userId: number | null = null;
  isArabic$: Observable<boolean> = this.store.select(selectIsArabic);

  roles = Roles;

  isUserPending = false;
  isUserBlocked = false;

  isLogingIn$ = this.store.select(selectAuthLogingIn);
  isLoading$ = this.store.select(selectAuthLoading);

  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private store: Store,
    private facebookService: FacebookService
  ) {
    this.store.dispatch(AuthActions.initAuth());
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart && event.url.startsWith('/saved-searches/unsubscribe')) {
        // Disable analytics for this session before entering the token-bearing route.
        (window as any)['ga-disable-G-R9P3SM8QK4'] = true;
      }
      if (event instanceof NavigationEnd && !(window as any)['ga-disable-G-R9P3SM8QK4']) {
        gtag('config', 'G-R9P3SM8QK4', {
          page_path: event.urlAfterRedirects,
        });
      }
    });

    this.store
      .select(selectAuthUser)
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user) {
          this.isLoggedIn = true;
          this.username = user.name;
          this.userId = user.id;
          this.isUserBlocked = user?.status === Statuses.Blocked;
          this.isUserPending = user.status === Statuses.Pending;
        } else {
          this.isLoggedIn = false;
          this.username = undefined;
          this.userId = null;
          this.isUserBlocked = false;
          this.isUserPending = false;
        }
      });

    this.facebookService.init();
  }

  logout() {
    this.store.dispatch(AuthActions.logout());
    this.username = undefined;
    this.isLoggedIn = false;
  }

  goToPage(route: string): void {
    this.router.navigate([route]);
  }

  toggleNavbar() {
    this.isNavbarOpen = !this.isNavbarOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.navbar.nativeElement.contains(event.target)) {
      this.isNavbarOpen = false;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
